module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-container"
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "type-wrap"
  }, [_c('router-link', {
    staticClass: "home-page",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页>")]), _vm._v(" "), _c('span', {
    staticClass: "type-name"
  }, [_vm._v("企业文化")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.info), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "media",
      on: {
        "click": function($event) {
          _vm.onClick(index)
        }
      }
    }, [_c('div', {
      staticClass: "media-left"
    }, [_c('img', {
      staticClass: "media-object",
      attrs: {
        "src": item.bannerUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "media-body"
    }, [_c('h3', {
      staticClass: "media-heading"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticClass: "txt"
    }, [_vm._v(_vm._s(item.summary))]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("发布日期：" + _vm._s(item.addDate))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "pagebar-box"
  }, [_c('pagination', {
    attrs: {
      "count": _vm.count,
      "page-size": _vm.pageSize,
      "current-page": _vm.currentPage
    },
    on: {
      "on-page-click": _vm.onPageClick
    }
  })], 1)]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__title"
  }, [_c('h2', {
    staticClass: "large__title"
  }, [_vm._v("企业文化")]), _vm._v(" "), _c('h4', {
    staticClass: "small__title square"
  }, [_vm._v("CORPORATE CULTURE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-caption"
  }, [_c('div', {
    staticClass: "point"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3305cc39"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/culture.vue
// module id = 592
// module chunks = 1